/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import bindMethods from 'auto-bind';
import styled from 'styled-components';
import pick from 'lodash/pick';

import { DisplayPasswordIcon } from '../../icons/TogglePasswordIcon';

const FieldGroup = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-top: 20px;
  }

  & label {
    font-size: 14px;
  }

  & label {
    font-size: 14px;
    font-weight: bold;
    color: ${props => (props.error ? props.theme.WARNING : props.theme.BLACK)};
    margin-bottom: 4px;
  }
`;

const InputField = styled(Field)`
  width: 385px;
  height: ${props => (props.component === 'textarea' ? null : '36px')};
  border-radius: 1px;
  border: ${props => props.error ? `solid 1px ${props.theme.WARNING}` : `solid 1px ${props.theme.GREY}`};
  padding: 8px 11px;
  font-size: 14px;
  font-weight: normal;
`;
const PasswordFieldContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ErrorMessage = styled.span`
  margin-left: 8px;
  font-size: 12px;
  font-weight: 400;
`;

const PasswordField = styled(Field)`
  display: flex;
  width: 344px;
  height: 36px;
  border-radius: 1px;
  border: ${props => props.error ? `solid 1px ${props.theme.WARNING}` : `solid 1px ${props.theme.GREY}`};
  border-right: none;
  padding: 8px 11px;
  font-size: 14px;
  font-weight: normal;
`;

const TogglePassword = styled.div`
  height: 36px;
  width: 41px;
  padding: 0 5px;
  border: ${props => props.error ? `solid 1px ${props.theme.WARNING}` : `solid 1px ${props.theme.GREY}`};
  border-left: none;
  display: flex;
  align-items: center;
`;

export function FormInputField(props) {
  const {
    inputId, label, labelId, name, isRequired, placeholder, type, error, isReadOnly,
  } = props;

  const additionalProps = pick(props, ['checked', 'error', 'rows', 'component']);

  return (
    <FieldGroup isRequired={isRequired} error={error}>
      <label htmlFor={name} id={labelId}>
        {label}
        {isRequired && <span>*</span>}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </label>
      <InputField
        {...additionalProps}
        id={inputId}
        name={name}
        type={type}
        placeholder={placeholder}
        required={isRequired}
        disabled={isReadOnly}
      />
    </FieldGroup>
  );
}

export class PasswordInputField extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
    bindMethods(this);
  }

  togglePasswordDisplay() {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword,
    }));
  }

  render() {
    const {
      inputId, label, labelId, name, placeholder, error, isRequired,
    } = this.props;
    const { showPassword } = this.state;

    return (
      <FieldGroup isRequired error={error}>
        <label htmlFor={name} id={labelId}>
          {label}
          {isRequired && <span>*</span>}
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </label>
        <PasswordFieldContainer>
          <PasswordField
            error={error}
            id={inputId}
            name={name}
            type={showPassword ? 'text' : 'password'}
            placeholder={placeholder}
            required={isRequired}
          />
          <TogglePassword onClick={this.togglePasswordDisplay}>
            <DisplayPasswordIcon />
          </TogglePassword>
        </PasswordFieldContainer>
      </FieldGroup>
    );
  }
}

FormInputField.propTypes = {
  error: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  isReadOnly: PropTypes.bool,
};

FormInputField.defaultProps = {
  isRequired: false,
  type: 'text',
  isReadOnly: false,
};

PasswordInputField.propTypes = {
  error: PropTypes.string,
  isRequired: PropTypes.bool,
  inputId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};
